import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import "./Commodities.css";
import { useRecommendation } from "../../context/RecommendationContext";
const Commodities = () => {
  const [commData, setCommData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [lastUpdated, setLastUpdated] = useState("");
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { selectedRecommendation } = useRecommendation();
  console.log("SelectedRecommendation", selectedRecommendation);
  const stock = selectedRecommendation;
  // useEffect(() => {
  //   const fetchCommodities = async () => {
  //     try {
  //       setLoading(true);
  //       const response = await axios.get(`${BASE_URL}/api/commodities`);
  //       console.log("News data", response.data);
  //       setCommData(response.data);
  //       // setStock(response.data);
  //     } catch (err) {
  //       console.log("Error is :-", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchCommodities();
  // }, []);
  // console.log("Commodities", commData);
  return (
    <>
      <div className="stock-table-container">
        <table className="stock-table">
          <thead>
            <tr>
              <th>Product</th>
              <th>Sell Price</th>
              <th>Quantity</th>
              <th>Low</th>
              <th>High</th>
              <th>Close</th>
              <th>%Change</th>
              <th>%OI</th>
              <th>Last Price</th>

              <th>Month</th>
              <th>Recommendation</th>
            </tr>
          </thead>
          <tbody>
            <tr className="stock-row">
              <td>{stock.product}</td>
              <td>{stock.sell_price}</td>
              <td>{stock.sell_quantity}</td>
              <td>{stock.low_price}</td>
              <td>{stock.high_price}</td>
              <td>{stock.close_price}</td>

              <td
                style={{
                  color: stock.percent_change >= 0 ? "#2fd18a" : "#f87171",
                  fontWeight: "bold",
                }}
              >
                {stock.per_change}%
              </td>
              <td
                style={{
                  color:
                    stock.open_interest_per_change >= 0 ? "#2fd18a" : "#f87171",
                  fontWeight: "bold",
                }}
              >
                {stock.open_interest_per_change}
              </td>
              <td>{stock.last_traded_price}</td>

              <td>{stock.product_month}</td>
              <td>
                <button className="rec-btn">BUY or SELL</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Commodities;
